var map = {
	"./bookmarks/bookmarks.module": [
		"./src/app/modules/home/bookmarks/bookmarks.module.ts",
		"bookmarks-bookmarks-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/modules/home/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./favorites/favorites.module": [
		"./src/app/modules/home/favorites/favorites.module.ts",
		"favorites-favorites-module"
	],
	"./help/help.module": [
		"./src/app/modules/home/help/help.module.ts",
		"help-help-module"
	],
	"./modules/direct-login/direct-login.module": [
		"./src/app/modules/direct-login/direct-login.module.ts",
		"modules-direct-login-direct-login-module"
	],
	"./modules/home/home.module": [
		"./src/app/modules/home/home.module.ts",
		"default~modules-home-home-module~tutorial-tutorial-module",
		"common",
		"modules-home-home-module"
	],
	"./modules/login/login.module": [
		"./src/app/modules/login/login.module.ts",
		"modules-login-login-module"
	],
	"./modules/welcome-page/welcome-page.module": [
		"./src/app/modules/welcome-page/welcome-page.module.ts",
		"modules-welcome-page-welcome-page-module"
	],
	"./notes/notes.module": [
		"./src/app/modules/home/notes/notes.module.ts",
		"notes-notes-module"
	],
	"./search-results/search-results.module": [
		"./src/app/modules/home/search-results/search-results.module.ts",
		"search-results-search-results-module"
	],
	"./search/search.module": [
		"./src/app/modules/home/search/search.module.ts",
		"search-search-module"
	],
	"./tutorial/tutorial.module": [
		"./src/app/modules/home/tutorial/tutorial.module.ts",
		"default~modules-home-home-module~tutorial-tutorial-module",
		"common",
		"tutorial-tutorial-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;